import React from 'react';
import logo from '../images/logo_transparent.png';

/**
 * CameraPlaceholder — no-signal / disabled-camera tile.
 *
 * A solid grey card (the DIVIDIA brand grey #b9b7bb) with the logo centered.
 * No border, no stretch, no letterbox seams — the grey fills the whole tile
 * and the logo sits at natural aspect in the middle, at any tile size.
 * Inline styles intentionally override the global `.live-video-stream img`
 * (object-fit:fill / black bg) rule that stretches real streams.
 *
 * The logo is capped on BOTH axes (max-width 62% AND max-height 62%) so it never
 * overflows a SHORT tile — e.g. a wide-short cell in a landscape multi-cam grid,
 * where a width-only cap let the proportional height spill below the tile
 * (David #86bb7phhh). object-fit:contain keeps its aspect when the height cap engages.
 */
const CameraPlaceholder = () => (
  <div style={{
    position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    background: '#b9b7bb',
    boxShadow: [
      'inset 0 0 0 1px rgba(0,0,0,0.28)',   // crisp hairline edge — defines the frame
      'inset 0 2px 7px rgba(0,0,0,0.34)',   // directional top shadow — reads as recessed
      'inset 0 0 18px rgba(0,0,0,0.16)',    // soft ambient depth
      'inset 0 0 46px rgba(0,0,0,0.12)',    // deep soft vignette — reaches further toward center
    ].join(', '),
  }}>
    <img
      src={logo}
      alt="No signal"
      style={{
        width: '62%', maxWidth: '230px', height: 'auto', maxHeight: '62%',
        objectFit: 'contain', background: 'transparent', border: 'none', opacity: 0.92,
      }}
    />
  </div>
);

export default CameraPlaceholder;
